import InquiryFlowApp from '../inquiry_flow/components/InquiryFlowApp.vue';
import { mountVueWithProps } from '../common/utils/vue';

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('inquiry-flow-app');
  if (element) {
    mountVueWithProps({ element, component: InquiryFlowApp });
  }
});
